import type { ReactNode } from "react";
import "../job-quest.css";
import "../quest-board.css";

export function QuestLayout({
  current,
  children,
}: {
  current: "top" | "board" | "detail" | "apply";
  children: ReactNode;
}) {
  return (
    <main id="top" className="jq-page">
      <a className="jq-skip-link" href="#quest-content">
        Job Questの本文へ移動
      </a>
      <div className="jq-service-nav">
        <div className="content-width jq-service-inner">
          <a
            href="/job-quest/"
            className="jq-service-brand"
            aria-current={current === "top" ? "page" : undefined}
          >
            AIYSS <strong>JOB QUEST</strong>
            <span aria-hidden="true">↗</span>
          </a>
          <nav aria-label="Job Quest">
            <a
              href="/job-quest/board/"
              aria-current={current === "board" ? "page" : undefined}
            >
              Quest Board
            </a>
            <a href="/contact/?type=job-quest#contact">企業の方へ</a>
          </nav>
        </div>
      </div>
      <div id="quest-content" tabIndex={-1}>
        {children}
      </div>
    </main>
  );
}
